import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import PosluhdesDetailPage from '@/components/pages/guest/_ext-intitutions/containers/details/posluhdes'

export const Route = createFileRoute(
  '/_guest/guest/extensions-institutions/posluhdes/$id'
)({
  component: RouteComponent,
  validateSearch: z.object({
    province_code: z.string().optional(),
    city_code: z.string().optional(),
    district_code: z.string().optional()
  })
})

function RouteComponent() {
  return <PosluhdesDetailPage />
}
